/* 216 addendum 6 §10 (2) [RULED 81] — THE MATTER CHIP, ONE DEFINITION: the pill
   an event card wears on its second row to name the matter it belongs to (115
   §2, the Dashboard's; 195 §A, the Archive's, whole), extracted from
   CaseEventRow.tsx — its rendering byte for byte (SESSION_RULES rule 3: moved,
   not bettered) — so a task's card can wear the same one (Laurent, 15/10: « the
   case name should be a "pill" like for Events »). `label` is cut at 20
   characters unless `full` (102 §1a; 193 §H); `title` is the hover; `onClick`
   the jump, with stopPropagation because the card itself may navigate to the
   same place — one jump, not two; a chip with no onClick names the matter and
   jumps nowhere (195 §A). Hookless, at module scope (the Bug-A lint). */
import React from "react";
import { FS } from "../lib/tokens";

export interface MatterChipSpec { label: string; title?: string; onClick?: () => void; full?: boolean }

export default function MatterChip({ chip }: Readonly<{ chip: MatterChipSpec }>) {
  /* 195 §A — `full`: the Archive's chip names the matter WHOLE (193 §H: title —
     ref), the Dashboard keeps 102 §1a's 20-character cut on its busier line. */
  const label = !chip.full && chip.label.length > 20 ? chip.label.slice(0, 20) + "…" : chip.label;
  /* §7 — and the last 2px are the pill's own: `.lib-pill` is `margin: 1px 2px`
     (App.css:1166), so the mirror landed its MARGIN box on the timer's x and its
     border box 2px right (measured: timer 379, chip 381). The margin separated
     it from a neighbour it no longer has — it leads the line — and the vertical
     half is kept. */
  /* 195 §A — a chip with no onClick names the matter and jumps nowhere (the
     Archive's cards): a span. Where it jumps it is a BUTTON (a new file is
     ESLint-clean: no clickable span where a button will do), wearing the same
     class, its own chrome and face released (`font: inherit`, no border) so it
     renders as the span did; the jump stops propagation because the card itself
     may navigate to the same place — one jump, not two. */
  if (!chip.onClick) {
    return (
      <span className="lib-pill" style={{ fontSize: FS.s9_5, marginLeft: 0, cursor: "default" }} title={chip.title}>
        {label}
      </span>
    );
  }
  const jump = chip.onClick;
  return (
    <button
      type="button"
      className="lib-pill"
      style={{ font: "inherit", fontSize: FS.s9_5, lineHeight: "inherit", border: "none", marginLeft: 0 }}
      title={chip.title}
      onClick={(e) => {
        e.stopPropagation();
        jump();
      }}
    >
      {label}
      {/* 216 addendum 6 §10 (2) [RULED 81] — the jump glyph « › » that followed the label where the chip jumps
          is gone (Laurent, 15/10: « the case name pill should have no arrow, unneeded clutter »): one chip, so the
          Archive's and the Dashboard's alike; the cursor still says where it jumps. */}
    </button>
  );
}
